// extracted by mini-css-extract-plugin
module.exports = {"root":"TextCounter_root__1q5XP"};